// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lk-my-requests .table__row{grid-template-columns:15% 35% 15% 20% 15%}", ""]);
// Exports
module.exports = exports;
